var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43451 3.93427C3.74693 3.62185 4.25346 3.62185 4.56588 3.93427L8.0002 7.36858L11.4345 3.93427C11.7469 3.62185 12.2535 3.62185 12.5659 3.93427C12.8783 4.24669 12.8783 4.75322 12.5659 5.06564L9.13157 8.49995L12.5659 11.9343C12.8783 12.2467 12.8783 12.7532 12.5659 13.0656C12.2535 13.3781 11.7469 13.3781 11.4345 13.0656L8.0002 9.63132L4.56588 13.0656C4.25346 13.3781 3.74693 13.3781 3.43451 13.0656C3.12209 12.7532 3.12209 12.2467 3.43451 11.9343L6.86882 8.49995L3.43451 5.06564C3.12209 4.75322 3.12209 4.24669 3.43451 3.93427Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXclose);
export default __webpack_public_path__ + "static/media/icon_xclose.8c397a916b3bf1fbcac611e1ff3cb74b.svg";
export { ForwardRef as ReactComponent };